import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'

import {
  DEFAULT_DRIVE_TIME_RADIUS_KM,
  DRIVE_TIME_EXTENDED_RADIUS_KM,
} from '@/constants'

const EXTENDED_COUNTRIES = ['de', 'dk']

export const getDriveTimeRadiusKm = ({
  brand,
  country,
}: {
  brand: Brand
  country: string | undefined
}): number => {
  const normalisedCountry = country?.toString().trim().toLowerCase() ?? ''

  if (brand === 'novasol' && EXTENDED_COUNTRIES.includes(normalisedCountry)) {
    return DRIVE_TIME_EXTENDED_RADIUS_KM
  }

  return DEFAULT_DRIVE_TIME_RADIUS_KM
}
